import React from 'react';
import {PreSignUpComponent} from '../../components/PreSignUp';

export const PreSignUp: React.FC = React.memo(() => {
  return <PreSignUpComponent />;
});
